import ReactMarkdown from 'react-markdown'
import style from './index.module.less'

interface Props {
  highlights: string
}

const ProductBenefits: React.FC<Props> = ({ highlights }) => {
  // TODO: This is a temporary fix for API / Cloud sync escaping dashes which prevents rendering them as list items
  highlights = highlights.replace(/\\-/g, '-')
  return (
    <ReactMarkdown className={style.productBenefits}>
      {highlights}
    </ReactMarkdown>
  )
}
export default ProductBenefits
